import { createConfirmation } from "react-confirm";
import AddItemDialog from "./AddItemDialog";

export const showAddItemDialog = createConfirmation(AddItemDialog);
